import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError,throwError } from 'rxjs';
import { GlobalServicesService } from './global-services.service';

@Injectable({
  providedIn: 'root'
})
export class TalentPoolService {

  host_api_url = environment.HOST.HOST_API_URL;
  fast_api_url = environment.HOST.FAST_API_URL;
  constructor(private http: HttpClient, private globalService: GlobalServicesService ) { }
  //Fast APIs
  getAllCandidatesFastApi(pageNumber: number = 1, pageSize: number = 10, orderBy: string = 'asc', sortBy: string = 'id', searchEmail = ''): Observable<HttpResponse<any>> {
    let params = new HttpParams()
      .set('page', pageNumber.toString())
      .set('size', pageSize.toString())
      .set('order_by', orderBy)
      .set('sort_by', sortBy);
    
    if (searchEmail && searchEmail.trim() !== '') {
      params = params.set('s', searchEmail.trim());
    }

    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/candidates`, {
      params,
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  //candidate invite APIs
  getCandidateInviteFormDataFastApi(): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/candidates/form-data`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  // Bulk Invite Candidates API
  candidateSingleInviteFastApi(eventId: string, payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/candidates/invite`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  // Bulk Invite File Download API
  bulkInviteFileDownloadFastApi(): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/candidates/invite/template`, {
      observe: 'response',
      responseType: 'blob' as 'json',  // Assuming it's a file download
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  // Bulk Registration File Download API
  bulkRegistrationFileDownloadFastApi(eventId: string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/candidates/register/template/event/${eventId}`, {
      observe: 'response',
      responseType: 'blob' as 'json',  // Assuming it's a file download
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  // Move Candidate to Event API
  candidateMoveToEventFastApi(eventId: string, payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/candidates/move-to-event`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }
  // Get Category wise Events API
  getCategoryWiseEventsFastApi(categoryId:string): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/event-categories/${categoryId}`, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }

  moveCandidatesFastApi(eventId: string, payload: any): Observable<HttpResponse<any>> {
    return this.http.post<HttpResponse<any>>(`${this.fast_api_url}/events/${eventId}/candidates/move-to-event`, payload, {
      observe: 'response',
    }).pipe(
      catchError(this.globalService.handleError.bind(this.globalService))
    );
  }


  getAllEventsByCategory(
    categoryId: string | number,
    page: number = 1,
    size: number = 10,
    orderBy: 'asc' | 'desc' = 'asc',
    sortBy: string = 'name',
    searchQuery: string = '',
    eventStatus: string = 'all'
    ): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('order_by', orderBy)
      .set('sort_by', sortBy)
      .set('event_category_id', categoryId.toString())
      .set('event_status', eventStatus);

    if (searchQuery && searchQuery.trim() !== '') {
      params = params.set('s', searchQuery.trim());
    }

    return this.http.get(`${this.fast_api_url}/events`, {
        params,
        observe: 'response'
    }).pipe(
        catchError(this.globalService.handleError.bind(this.globalService))
    );
}

    bulkInviteFastApi(payload:any ,eventId: string): Observable<HttpResponse<any>> {
      return this.http.post<HttpResponse<any>>( `${this.fast_api_url}/events/${eventId}/candidates/bulk-invite`, payload, {
        observe: 'response',
      }).pipe(
        catchError((error: HttpErrorResponse) => throwError(() => error))
      );
    }
    
    bulkRegisterFastApi(payload:any ,eventId: string): Observable<HttpResponse<any>> {
      return this.http.post<HttpResponse<any>>( `${this.fast_api_url}/events/${eventId}/candidates/bulk-register`, payload, {
        observe: 'response',
      }).pipe(
        catchError((error: HttpErrorResponse) => throwError(() => error))
      );
    }

    getCandidateEventDetailsFastApi(candidateId: string): Observable<HttpResponse<any>> {
      return this.http.get<HttpResponse<any>>(`${this.fast_api_url}/candidates/${candidateId}`, {
        observe: 'response',
      }).pipe(
        catchError(this.globalService.handleError.bind(this.globalService))
      );
    }
}
